import React, { useState, useEffect } from "react";
import { Stack } from "@mui/material";
import axios from "axios";
import _ from "lodash";
import { context_header_styles } from "./context_builder_dark_styles";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import "./context_dark.css";
import { makeStyles } from "@mui/styles";
import { useDrag } from "@use-gesture/react";
import { useSpring, animated } from "@react-spring/web";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Collapse } from "@mui/material";
import Default from "./pages/default";
import Analyze from "./pages/audit_analysis";
import moment from "moment";
import { projectInfoActions, contextBuilderActions } from "../store/store";
import { useSelector, useDispatch } from "react-redux";
import Preferences from "./pages/preferences";
import ProjectSwitcher from "./pages/projectSwitcher";
import { ContextSnackbar } from "./context_components/snackbar";
import { DotLoader } from "./context_components/dot_loader";
import SosAndSodAnalyze from "./pages/sos_sod_analysis";
import QaAnalysis from "./pages/qa_analysis";

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function ContextBuilder(props) {
  const pos = useSelector((state) => state.contextBuilderStore.pos);
  const openContext = useSelector(
    (state) => state.contextBuilderStore.openContext
  );
  const selectedPage = useSelector((state) => state.contextBuilderStore.page);
  const dispatch = useDispatch();

  const bind = useDrag(({ event, offset: [x, y] }) => {
    const targetClasses = event.target.classList;

    // Check if the drag icon is being dragged
    if (targetClasses.contains("drag-indicator-dark")) {
      dispatch(
        contextBuilderActions.setPos({
          x: x + (window.innerWidth - 325),
          y: y + 100,
        })
      );
    }
  });

  const navigate = useNavigate();
  const [springs, api] = useSpring(() => ({
    from: {
      x: window.innerWidth - 300,
    },
    config: {
      mass: 2.5,
    },
  }));

  useEffect(() => {
    dispatch(contextBuilderActions.setPos(pos));
  }, [pos, dispatch]);

  useEffect(() => {
    api.start({
      from: {
        x: "-100%",
        scale: 0,
      },
      to: {
        x: "0%",
        scale: 1,
      },
    });
  }, [openContext]);

  const handleContextOpen = () => {
    dispatch(contextBuilderActions.setPos({ x: pos.x, y: pos.y }));
    dispatch(contextBuilderActions.setopenContext(!openContext));
  };

  useEffect(() => {}, [selectedPage]);

  useEffect(() => {
    setInterval(() => {
      const updatedDateTime = moment(new Date()).format(
        "MMM DD, YYYY hh:mm:ss a"
      );
      dispatch(projectInfoActions.updateDateTime(updatedDateTime));
    }, 1000);
  }, []);

  const pages = [
    {
      name: "default",
      page: <Default />,
    },
    {
      name: "analyze",
      page: <Analyze />,
    },
    {
      name: "sosAndSod",
      page: <SosAndSodAnalyze />,
    },
    //below code added
    {
      name: "qaAnalysis",
      page: <QaAnalysis />,
    },
    {
      name: "preferences",
      page: <Preferences />,
    },
    {
      name: "projects",
      page: <ProjectSwitcher />,
    },
  ];

  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage("preferences"));
    dispatch(contextBuilderActions.setPrevPage(selectedPage));
  };

  const currentPage = pages.filter((page) => page.name === selectedPage)[0][
    "page"
  ];

  return (
    <animated.div
      {...bind()}
      style={{
        position: "fixed",
        zIndex: 999,
        top: pos.y,
        left: pos.x,
        // ...springs,
      }}
    >
      <Stack spacing={0.7}>
        <div className="drag-indicator-dark" style={context_header_styles}>
          <div
            onClick={handleContextOpen}
            style={{
              color: "rgb(250,250,250)",
              fontSize: "1.25rem",
              letterSpacing: "0.02rem",
              cursor: "pointer",
              textShadow: "0 0 3px #fff",
            }}
          >
            context
          </div>
          <div style={{ justifyContent: "center", alignItems: "center" }}>
            <DotLoader />
          </div>
          <DragIndicatorIcon
            sx={{
              fontSize: "1.7rem",
              cursor: "pointer",
              transform: "rotate(90deg)",
            }}
            onClick={handlePageChange}
          />
        </div>

        <Collapse in={openContext} timeout={350} unmountOnExit>
          {/* pages */}
          {currentPage}
        </Collapse>
        <ContextSnackbar />
      </Stack>
    </animated.div>
  );
}
